import { ReactElement, ReactNode } from "react";
import { Alert } from "react-bootstrap";

const TenantSettingAlert = ({ allow, children }: { allow: boolean | undefined; children: ReactNode }): ReactElement =>
  allow ? <></> : <Alert variant='danger'>{children}</Alert>;

export default TenantSettingAlert;
